import { h } from 'preact'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

import TextInput from './input/TextInput'
import Email from './input/Email'
import TextArea from './input/TextArea'

const CardUser = (props) => {
  let { formControls, handleChange } = props

  return (
    <div className="c-personalizer-card">

      <div className="c-personalizer-card__header">
        <h3 className="c-personalizer-card__title">4. Contactgegevens</h3>
      </div>

      <div class="c-personalizer-row">
        <p class="c-personalizer-row__title">Jouw contactgegevens</p>
        
        <div class="c-personalizer-row__wide">
          <div class="u-flex u-flex-sb">
            <div class="c-personalizer-row__col">
              <TextInput name="firstname" 
                placeholder={formControls.firstname.placeholder}
                value={formControls.firstname.value}
                onChange={handleChange}
                touched={formControls.firstname.touched}
                valid={formControls.firstname.valid}
                error={formControls.firstname.error}
              /> 
            </div>
            <div class="c-personalizer-row__col">
            <TextInput name="lastname" 
                placeholder={formControls.lastname.placeholder}
                value={formControls.lastname.value}
                onChange={handleChange}
                touched={formControls.lastname.touched}
                valid={formControls.lastname.valid}
                error={formControls.lastname.error}
              />
            </div>
          </div>

          <TextInput name="company" 
            placeholder={formControls.company.placeholder}
            value={formControls.company.value}
            onChange={handleChange}
            touched={formControls.company.touched}
            valid={formControls.company.valid}
            error={formControls.company.error}
          /> 

          <div class="u-flex u-flex-sb">
            <div class="c-personalizer-row__col">
              <TextInput name="phone" 
                placeholder={formControls.phone.placeholder}
                value={formControls.phone.value}
                onChange={handleChange}
                touched={formControls.phone.touched}
                valid={formControls.phone.valid}
                error={formControls.phone.error}
              />
            </div>
            <div class="c-personalizer-row__col">
              <Email name="email"
                placeholder={formControls.email.placeholder}
                value={formControls.email.value}
                onChange={handleChange}
                touched={formControls.email.touched}
                valid={formControls.email.valid}
                error={formControls.email.error}
              />
            </div>
          </div>

          <TextInput name="address" 
            placeholder={formControls.address.placeholder}
            value={formControls.address.value}
            onChange={handleChange}
            touched={formControls.address.touched}
            valid={formControls.address.valid}
            error={formControls.address.error}
          />

          <div class="u-flex u-flex-sb">
            <div class="c-personalizer-row__col">
              <TextInput name="zip" 
                placeholder={formControls.zip.placeholder}
                value={formControls.zip.value}
                onChange={handleChange}
                touched={formControls.zip.touched}
                valid={formControls.zip.valid}
                error={formControls.zip.error}
              /> 
            </div>
            <div class="c-personalizer-row__col">
              <TextInput name="city" 
                placeholder={formControls.city.placeholder}
                value={formControls.city.value}
                onChange={handleChange}
                touched={formControls.city.touched}
                valid={formControls.city.valid}
                error={formControls.city.error}
              />
            </div>
          </div>
        
          <TextArea name="message"
            placeholder={formControls.message.placeholder}
            value={formControls.message.value}
            onChange={handleChange}
            touched={formControls.message.touched}
            valid={formControls.message.valid}
            error={formControls.message.error}
          />
        </div>

      </div>

    </div>
  )
}

export default CardUser



// WEBPACK FOOTER //
// ./src/js/personalizer/components/CardUser.js